import styled from 'styled-components';
import tw from 'twin.macro';

export const StyledStepIcon = styled.div`
    ${tw`flex justify-center w-8 h-8 py-3 transition duration-500 ease-in-out border-2 rounded-full`}
    svg {
        ${tw`absolute h-4 bottom-2`}
    }
`
export const StyledStepLabel = styled.div`
    ${tw`absolute top-0 w-32 mt-10 -ml-12 text-xs font-medium text-center uppercase md:text-sm`}
`

export const StyledStepSpacer = styled.div`
    ${tw`flex-auto transition duration-500 ease-in-out border-t-2`}
    ${({ active }) => active ? tw`border-primary-dark` : tw`border-gray-300`}
`

export const StyledStep = styled.div`
    ${tw`relative flex items-center text-gray-500`}
    ${({ active, visited }) => [
        visited && tw`text-primary-dark`,
        active && tw`text-white!`,
    ]}
    ${StyledStepIcon} {
        ${({ active, visited }) => [
            active && tw`bg-primary-dark`,
            visited && tw`border-primary-dark`,
        ]}
    }
    ${StyledStepLabel} {
        ${({ visited }) => [
            visited && tw`text-primary-dark`,
        ]}
    }
`;